var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 97L21 94.5458C20.3997 94.0374 19.8134 93.5221 19.2411 93C19.1218 94.3191 19.0415 95.6524 19 97Z",
    fill: "#A70000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20L14.5152 22C15.0038 21.3512 15.4987 20.7229 16 20.1152C14.6746 20.0373 13.3412 19.9989 12 20Z",
    fill: "#A70000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97611 57.2509C13.4433 48.1649 25.9055 43.2144 37.7005 41.2012C39.6534 40.8668 41.5833 40.612 43.4903 40.4368C45.6431 40.2358 47.7568 40.1314 49.8143 40.1203C51.805 39.4521 53.9065 39.1893 55.9978 39.3471C58.0891 39.5049 60.129 40.0802 62 41.0398C60.4127 39.4856 58.7067 37.9584 56.8914 36.4802C55.4026 35.2663 53.8387 34.084 52.2046 32.9477C42.3561 26.0774 30.0017 20.8467 16.2413 20H16.1679C15.6721 20.5961 15.1836 21.2091 14.7025 21.839C6.91458 31.968 0.798317 45.8305 0 60C0.952981 59.0631 1.92523 58.1662 2.91674 57.3095L2.97611 57.2509Z",
    fill: "url(#paint0_linear_603_96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0444 20.2898C29.906 21.1283 42.3555 26.308 52.2861 33.1067C53.9296 34.232 55.5055 35.4027 57.009 36.6048C58.8383 38.0686 60.5574 39.5826 62.1569 41.12C65.8166 42.9715 68.6238 46.1497 70 50C69.9276 47.7729 69.7481 45.4785 69.4569 43.1418C69.2176 41.2391 68.9043 39.3083 68.5123 37.3618C66.1304 25.5981 60.7983 13.2576 51.4344 3.05329L51.384 3C50.6126 3.07941 49.8349 3.17449 49.0509 3.28524C36.4046 5.05465 22.3856 10.6513 12 20.1723C13.3381 20.1723 14.6642 20.2109 15.9782 20.2882L16.0444 20.2898Z",
    fill: "url(#paint1_linear_603_96)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.751 2.8161L51.801 2.86912C61.1058 13.0218 66.3921 25.2997 68.7569 37.0039C69.1493 38.9405 69.4603 40.8616 69.6948 42.7546C69.9839 45.0795 70.1637 47.3623 70.234 49.5781C71.5528 53.2924 71.4414 57.363 69.9214 61C71.3282 59.4407 72.7083 57.7691 74.0416 56.0102C75.1879 54.4852 76.2997 52.8906 77.3772 51.2263C83.8388 41.1781 88.6045 28.6881 89 14.9381C89 14.9132 89 14.8898 89 14.8649C88.3935 14.3908 87.773 13.923 87.1384 13.4615C76.8911 6.01112 63.0096 0.350844 49 0C49.9524 0.914792 50.8694 1.85349 51.751 2.8161Z",
    fill: "url(#paint2_linear_603_96)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.374 48.9833C108.27 48.3456 109.145 47.6845 110 47L107 47.3772C107.13 47.9219 107.246 48.4628 107.349 49L107.374 48.9833Z",
    fill: "#A70000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.769 14.9282C88.769 14.953 88.769 14.9763 88.769 15.0011C88.3763 28.6816 83.6462 41.1085 77.2256 51.1059C76.1638 52.7607 75.0595 54.3473 73.9129 55.8656C72.5887 57.6234 71.218 59.2788 69.8208 60.8302C68.3095 64.4231 65.5247 67.3322 62 69C63.9358 68.8449 65.9151 68.6075 67.9238 68.2832C69.7991 67.9823 71.6956 67.6037 73.6133 67.1476C85.1722 64.3861 97.2092 58.8304 106.972 49.2395L107 49.2131C106.897 48.4653 106.78 47.7134 106.649 46.9574C104.496 34.5646 98.5132 20.9291 88.7581 11C88.8037 12.3228 88.8073 13.6323 88.769 14.9282Z",
    fill: "url(#paint3_linear_603_96)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.139 92.9592C20.434 78.965 26.1211 66.5606 33.3505 56.7993C34.1658 55.6985 35.0009 54.6317 35.8559 53.5991C37.4107 51.7101 39.0173 49.9439 40.652 48.3005C41.5759 46.3568 42.8798 44.6201 44.4858 43.194C46.0919 41.7679 47.9673 40.6816 50 40C47.9378 40.0157 45.8192 40.1196 43.6615 40.3148C41.7533 40.4911 39.819 40.7446 37.8585 41.0751C26.0365 43.0775 13.5427 48.0014 3.05481 57.0386L3 57.0874C3.05428 57.8598 3.12422 58.64 3.20982 59.4282C4.57366 72.1237 9.71428 86.3147 18.8916 97C18.9323 95.662 19.0132 94.3381 19.1343 93.0284C19.1343 93.0017 19.1375 92.978 19.139 92.9592Z",
    fill: "url(#paint4_linear_603_96)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3766 106.935C46.6305 96.0269 42.1363 83.1976 40.5766 71.1861C40.4004 69.8282 40.2612 68.4849 40.159 67.1562C39.9806 64.8467 39.9102 62.581 39.9337 60.3781C39.1995 58.3815 38.8706 56.2582 38.9665 54.1326C39.0624 52.0071 39.5811 49.9221 40.4922 48C38.859 49.6358 37.254 51.3953 35.7007 53.274C34.8497 54.3018 34.0154 55.3636 33.1977 56.4594C25.9753 66.1738 20.2937 78.5221 19 92.4514C19 92.4764 19 92.4999 19 92.525C19.5736 93.0389 20.1633 93.5481 20.7692 94.0527C30.5243 102.18 44.0244 108.75 58 110C57.1813 109.102 56.3961 108.188 55.6441 107.26C55.5487 107.151 55.4627 107.043 55.3766 106.935Z",
    fill: "url(#paint5_linear_603_96)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.977 87.1309C91.8928 87.1398 87.8166 86.777 83.8002 86.047L83.5379 86.0009L83.0524 85.9071C74.3538 84.2483 66.3484 81.0059 59.417 76.9672C57.7153 75.9741 56.0803 74.9369 54.5119 73.8556C53.48 73.1469 52.4825 72.3874 51.5146 71.6172C51.0098 71.2308 50.5144 70.8418 50.0284 70.4503C47.7409 69.7235 45.6505 68.4956 43.9143 66.8588C42.1782 65.2219 40.8413 63.2188 40.0044 61C39.9809 63.1616 40.0512 65.3846 40.2292 67.6507C40.3332 68.9565 40.4722 70.2745 40.646 71.6049C42.2071 83.3904 46.6876 95.9785 55.4158 106.682C55.5017 106.788 55.5875 106.894 55.6765 107C56.3775 106.96 57.0893 106.906 57.8059 106.837C71.7858 105.506 88.5772 98.7735 100 86.9956C98.6762 87.0817 97.3612 87.1268 96.055 87.1309H95.977Z",
    fill: "url(#paint6_linear_603_96)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1583 86.9797H96.0127L96 87C97.3233 86.9932 98.6566 86.9435 100 86.851L97.4563 85C97.0299 85.674 96.5973 86.3339 96.1583 86.9797Z",
    fill: "#A70000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.235 49.8854L107.183 49.9348C97.2488 59.4381 85.0387 65.0438 73.3161 67.7487C71.3768 68.1962 69.45 68.5649 67.5484 68.8581C65.5336 69.1667 63.5486 69.3951 61.6077 69.5432C57.9716 71.2126 53.8295 71.4829 50 70.3008C50.4656 70.6835 50.9374 71.0656 51.4156 71.4473C52.3593 72.1673 53.3303 72.872 54.3285 73.5612C55.9014 74.6474 57.5445 75.6941 59.2579 76.7012C66.2634 80.804 74.3731 84.1076 83.1906 85.7894L83.6797 85.8836L83.944 85.9298C88.021 86.6619 92.1588 87.0199 96.3035 86.9991C96.7586 86.3912 97.2063 85.7699 97.6467 85.1352L97.738 85.1954L97.7977 85.1121C104.939 74.74 110.146 60.8453 109.997 47L109.925 47.0787L109.987 47.0679C109.094 48.0451 108.177 48.9843 107.235 49.8854Z",
    fill: "url(#paint7_linear_603_96)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.026 48.9594L107 48.9758V49C108.027 48.3579 109.027 47.6912 110 47L109.932 47.0077C108.982 47.682 108.014 48.3326 107.026 48.9594Z",
    fill: "#A70000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.026 48.9594L107 48.9758V49C108.027 48.3579 109.027 47.6912 110 47L109.932 47.0077C108.982 47.682 108.014 48.3326 107.026 48.9594Z",
    fill: "url(#paint8_linear_603_96)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.859 68.2981C69.7345 68.0005 71.6348 67.626 73.5475 67.1717C85.1089 64.4253 97.1512 58.7337 106.949 49.0846L107 49.0345V49L106.972 49.0266C97.2039 58.7117 85.1833 64.3219 73.6328 67.1169C71.7196 67.5785 69.8245 67.9608 67.9475 68.2637C65.9402 68.5911 63.9623 68.8292 62.0279 68.9875L62 69C63.9142 68.8402 65.8719 68.613 67.859 68.2981Z",
    fill: "url(#paint9_linear_603_96)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.859 68.2981C69.7345 68.0005 71.6348 67.626 73.5475 67.1717C85.1089 64.4253 97.1512 58.7337 106.949 49.0846L107 49.0345V49L106.972 49.0266C97.2039 58.7117 85.1833 64.3219 73.6328 67.1169C71.7196 67.5785 69.8245 67.9608 67.9475 68.2637C65.9402 68.5911 63.9623 68.8292 62.0279 68.9875L62 69C63.9142 68.8402 65.8719 68.613 67.859 68.2981Z",
    fill: "url(#paint10_linear_603_96)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8419 73.2109C53.8649 72.4879 52.9176 71.7509 52 71C52.9499 71.8069 53.9319 72.6057 54.9462 73.3496C56.4807 74.4804 58.0879 75.5691 59.7676 76.6159C66.5762 80.8553 74.4498 84.2587 83 86C74.3976 84.2361 66.4857 80.7859 59.651 76.4949C57.9815 75.4481 56.3784 74.3534 54.8419 73.2109Z",
    fill: "url(#paint11_linear_603_96)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8419 73.2109C53.8649 72.4879 52.9176 71.7509 52 71C52.9499 71.8069 53.9319 72.6057 54.9462 73.3496C56.4807 74.4804 58.0879 75.5691 59.7676 76.6159C66.5762 80.8553 74.4498 84.2587 83 86C74.3976 84.2361 66.4857 80.7859 59.651 76.4949C57.9815 75.4481 56.3784 74.3534 54.8419 73.2109Z",
    fill: "url(#paint12_linear_603_96)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87H96.2018C96.8114 86.3687 97.4108 85.7235 98 85.0646L97.8728 85C97.2588 85.681 96.6345 86.3477 96 87Z",
    fill: "#A70000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87H96.2018C96.8114 86.3687 97.4108 85.7235 98 85.0646L97.8728 85C97.2588 85.681 96.6345 86.3477 96 87Z",
    fill: "url(#paint13_linear_603_96)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_96",
    x1: 18.5784,
    y1: 74.4101,
    x2: 40.809,
    y2: 24.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_96",
    x1: -14.6212,
    y1: 25.4225,
    x2: 75.206,
    y2: 26.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_96",
    x1: 28.0458,
    y1: -17.957,
    x2: 87.4195,
    y2: 46.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_96",
    x1: 69.8953,
    y1: -9.84649,
    x2: 86.6166,
    y2: 68.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_603_96",
    x1: 36.9644,
    y1: 112.022,
    x2: 24.6545,
    y2: 39.1981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_603_96",
    x1: 78.674,
    y1: 99.6886,
    x2: 25.2448,
    y2: 68.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_603_96",
    x1: 121.375,
    y1: 75.7666,
    x2: 39.3644,
    y2: 85.2837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_603_96",
    x1: 110.344,
    y1: 21.7535,
    x2: 68.9814,
    y2: 87.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_603_96",
    x1: 122.488,
    y1: 33.9357,
    x2: 99.5236,
    y2: 89.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_603_96",
    x1: 69.8183,
    y1: -10.6256,
    x2: 86.8663,
    y2: 68.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_603_96",
    x1: 109.22,
    y1: 19.9259,
    x2: 66.7013,
    y2: 85.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_603_96",
    x1: 120.327,
    y1: 72.1538,
    x2: 39.5828,
    y2: 80.9282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_603_96",
    x1: 105.319,
    y1: 16.2318,
    x2: 60.8158,
    y2: 82.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_603_96",
    x1: 143.866,
    y1: 30.6374,
    x2: 105.274,
    y2: 110.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40b4e9483e58cfade1f50060dc2f1972.svg";
export { ForwardRef as ReactComponent };